import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function subBenefitsReducer() {
    return combineReducers({
        CalcKernelRep_PrefCatList: createItemReducer('SubBenefits', 'CalcKernelRep.PrefCatList', false),
        CalcKernelRep_PrefCatListParams: createItemReducerParams('SubBenefits', 'CalcKernelRep.PrefCatList'),
        CalcKernelRep_DisplayUserBenefits: createItemReducer('SubBenefits', 'CalcKernelRep.DisplayUserBenefits', false)
    });
}